import { useEffect } from 'react'
import { reconcileLandingAuthState } from '../utils/reconcileLandingAuthState'

/** app에서 로그인/로그아웃한 뒤 랜딩 탭으로 돌아올 때 헤더 상태를 갱신한다. */
export function useCrossDomainAuthSync(): void {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return
      reconcileLandingAuthState()
    }

    window.addEventListener('focus', reconcileLandingAuthState)
    window.addEventListener('pageshow', reconcileLandingAuthState)
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      window.removeEventListener('focus', reconcileLandingAuthState)
      window.removeEventListener('pageshow', reconcileLandingAuthState)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])
}
